import { Banknote, RotateCcw, ShieldCheck } from "lucide-react";

// Compact always-visible trust summary next to the buy buttons — deeper
// detail (WhatsApp inquiry, full return terms) lives in the Shipping &
// Returns tab instead of duplicating it here.
export function ProductTrustGrid({ isReturnable }: { isReturnable: boolean }) {
  return (
    <div className="grid grid-cols-3 rounded-2xl border border-border divide-x divide-border overflow-hidden">
      <div className="flex flex-col items-center text-center gap-1.5 py-4 px-2">
        <Banknote size={18} className="text-accent" aria-hidden />
        <p className="text-xs font-medium">Cash on Delivery</p>
        <p className="text-[11px] text-ink-muted">Pay when you receive</p>
      </div>
      <div className="flex flex-col items-center text-center gap-1.5 py-4 px-2">
        <RotateCcw size={18} className="text-accent" aria-hidden />
        <p className="text-xs font-medium">{isReturnable ? "Easy Returns" : "Final Sale"}</p>
        <p className="text-[11px] text-ink-muted">{isReturnable ? "7-day return policy" : "No returns"}</p>
      </div>
      <div className="flex flex-col items-center text-center gap-1.5 py-4 px-2">
        <ShieldCheck size={18} className="text-accent" aria-hidden />
        <p className="text-xs font-medium">Secure Checkout</p>
        <p className="text-[11px] text-ink-muted">Your details stay private</p>
      </div>
    </div>
  );
}
